import { Injectable } from '@angular/core';
import { ApiUrlConstant } from '@app-constants/api-url.constant';
import { environment } from '@app-environments/environment';
import { RestApiService } from '@app-services/rest/rest-api.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BoardsService extends RestApiService{

  apiUrl = ApiUrlConstant.apiUrl;
  CMSApiUrl = environment?.CMS_API;

  fetchBoardsList(): Observable<any>{
    const url = this.apiUrl + `/api/boards`;
    console.log(url)
    return this.get<any>(url);
  }
  fetchGradesList(): Observable<any>{
    const url = this.apiUrl + `/api/grades`;
    console.log(url)
    return this.get<any>(url);
  }
  fetchTargetExamList(): Observable<any>{
    const url = this.apiUrl + `/api/exams`;
    console.log(url)
    return this.get<any>(url);
  }
  fetchCMSTargetExamList(gradeId: any): Observable<any>{
    const url = this.CMSApiUrl + `exam/exams?gradeIds=${gradeId}`;
    console.log(url)
    return this.get<any>(url);
  }
  fetchStreamsList(): Observable<any>{
    const url = this.apiUrl + `/api/streams`;
    //console.log(url)
    return this.get<any>(url);
  }
  
  getTargetExams(thisRef: any) {
    const p = new Promise((resolve, reject) => {  
      this.fetchTargetExamList().subscribe((data: any) => {
        thisRef.exams = data;
        resolve(true);
      });
    })
    return p;
  }
  
  getStreams(thisRef: any) {
    const p = new Promise((resolve, reject) => {  
      this.fetchStreamsList().subscribe((data:any) => {
        thisRef.streams = data;
        resolve(true);
      })  
    })
    return p;
  }
  
  getGrades(thisRef: any) {
    const p = new Promise((resolve, reject) => {   
      
      this.fetchGradesList().subscribe((data: any) => {
        const grades = data;
        grades.sort((a: any, b: any) => {
          return Number(a.name.replaceAll(/[^0-9]/g, "")) - Number(b.name.replaceAll(/[^0-9]/g, ""));
        })
        for(let i =0, len = grades.length; i< len; i++ ) 
        {
          if(grades[i].name == "9th" || grades[i].name == "10th" || grades[i].name == "11th" || grades[i].name == "12th" || grades[i].name == "13th") {
            // if(grades[i].name == "11th" || grades[i].name == "12th" || grades[i].name == "13th") {
            thisRef.grades[thisRef.grades.length] = grades[i];
          }
        }
        resolve(true);
      });
    })
    return p;
  }
}
